<h2 mat-dialog-title>Project Upload</h2>

<mat-dialog-content class="my-2">
  @if (!precheckComplete) {
    @if (precheckLoading) {
      <div class="text-center">
        <div class="row gx-0">
          <mat-spinner class="mx-auto"></mat-spinner>
        </div>
        <div class="row gx-0 pt-3">
          <p class="mb-0">Loading data...</p>
        </div>
      </div>
    } @else {
      @if (precheckLoaded && precheckResult.length === 0 && !errorMsg) {
        <p>No valid projects found within the project file!</p>
      } @else if (errorMsg) {
        <div class="text-center text-danger">
          <h4>
            An Error Occured
          </h4>
          <div>{{ errorStatus }}</div>
          <div>{{ errorMsg }}</div>
        </div>
      } @else {
        <p>Select the projects within the project file you wish to load.</p>
        <p class="mb-0"><strong>Linked Project</strong> Linked projects only include the minimum set of tasks and relationships and generally don't need to be uploaded.</p>
        <p><mat-checkbox [formControl]="showLinked" (click)="filterData()">Show Linked Projects</mat-checkbox></p>
        <p><strong>Existing Project</strong> Existing projects already have a matching project in Ctrl key, the upload will update activities and relationships.</p>
        @let dispCol = ['proj_id', 'proj_short_name','link_proj','existing','selected'];
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="proj_id">
            <th mat-header-cell *matHeaderCellDef> Project ID </th>
            <td mat-cell *matCellDef="let element"> {{ element.proj_id }} </td>
          </ng-container>

          <ng-container matColumnDef="proj_short_name">
            <th mat-header-cell *matHeaderCellDef> Project Code </th>
            <td mat-cell *matCellDef="let element"> {{ element.proj_short_name }} </td>
          </ng-container>

          <ng-container matColumnDef="link_proj">
            <th mat-header-cell *matHeaderCellDef> Linked </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{ element.link_proj ? 'Y' : '' }} </td>
          </ng-container>

          <ng-container matColumnDef="existing">
            <th mat-header-cell *matHeaderCellDef> Existing </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{ element.existing ? 'Y' : '' }} </td>
          </ng-container>

          <ng-container matColumnDef="selected">
            <th mat-header-cell *matHeaderCellDef> Upload </th>
            <td mat-cell *matCellDef="let element">
              @let linkOverwriteWarning = (element.selected && element.link_proj && element.existing);
              <mat-checkbox [(ngModel)]="element.selected"
                matBadge="!" matBadgeOverlap="true" [matBadgeHidden]="!linkOverwriteWarning" [matTooltipDisabled]="!linkOverwriteWarning"
                matTooltip="This project seems to only be included as a referenced project due to activity relationships. Uploading this project may cause issues as only relationship specific activity information is included and activity information may be lost."></mat-checkbox>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="dispCol"></tr>
          <tr mat-row *matRowDef="let row; columns: dispCol;"></tr>
        </table>
        <div class="row gx-0 pt-1">
          <mat-form-field>
            <mat-label>Add to Portfolio</mat-label>
            <mat-select [formControl]="applyPortfolio">
              <mat-option>None</mat-option>
              @for (portfolio of _portfolioService.portfolios; track $index) {
                <mat-option [value]="portfolio.id">{{ portfolio.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row gx-0 pt-1">
          <mat-checkbox [formControl]="skipArchive" matTooltip="Selecting this will prevent changes from being archived">Skip change archive</mat-checkbox>
        </div>
      }
    }
  } @else {
    @if (!loaded && !errorMsg) {
      <div class="text-center">
        <div class="row gx-0">
          <mat-spinner class="mx-auto"></mat-spinner>
        </div>
        <div class="row pt-3">
          <span>{{ loadingMessage }}</span>
        </div>
        <div class="row mt-2">
          <div class="progress px-0">
            <div class="progress-bar" role="progressbar" [style.width]="loadingProgress + '%'" [attr.aria-valuenow]="loadingProgress" aria-valuemin="0" aria-valuemax="100">{{ loadingProgress | number:'1.0-0' }}%</div>
          </div>
        </div>
        @if (durationEstimate) {
          <div class="row mt-2">
            Elapsed duration: {{ elapsedTime | number:'1.0-0' }}s (estimated: {{ durationEstimate | number:'1.0-0' }}s)
          </div>
        }
      </div>
    } @else if (errorMsg) {
      <div class="text-center text-danger">
        <h4>
          An Error Occured
        </h4>
        <div>{{ errorStatus }}</div>
        <div>{{ errorMsg }}</div>
      </div>
    } @else {
      <div class="row">
        Projects Successfully Uploaded!
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (!loaded) {
    <button matButton="outlined" mat-dialog-close [color]="loading ? 'warning' : 'grey'" (click)="close()">Cancel</button>
  }
  @if (precheckLoaded && !precheckComplete && dataSource.length !== 0) {
    <button matButton="filled" [disabled]="!checkSomeSelected()" [color]="checkSomeSelected() ? 'success' : 'grey'" (click)="startUpload()">Confirm</button>
  }
  @if (precheckComplete && loaded && errorMsg === '') {
    <button matButton="outlined" [mat-dialog-close]="loadedProjects" color="success" [disabled]="!loaded">Close</button>
  }
</mat-dialog-actions>